export type FeatureKey =
  | 'kpi-details'
  | 'agent-modules'
  | 'leaderboard'
  | 'dashboard'
  | 'tickets'
  | 'ticket-transcripts'

export const ORG_ALLOW_ALL = new Set<string>(['proserve-master', 'jmi-dev'])

export const FEATURE_BLOCKS: Record<FeatureKey, Set<string>> = {
  'kpi-details': new Set(['perfect-aire', 'ps-csr-1', 'ps-csr-2']),
  'agent-modules': new Set(['perfect-aire', 'ps-csr-1', 'ps-csr-2']),
  leaderboard: new Set(['perfect-aire']),
  dashboard: new Set(['ps-csr-1', 'ps-csr-2']),
  tickets: new Set(['ps-csr-1', 'ps-csr-2']),
  'ticket-transcripts': new Set(['perfect-aire'])
}

export function canAccess(
  feature: FeatureKey,
  orgSlug?: string | null,
  role?: string | null
) {
  if (!orgSlug) return false

  if (ORG_ALLOW_ALL.has(orgSlug)) return true

  const blocked = FEATURE_BLOCKS[feature]
  if (blocked?.has(orgSlug)) return false

  if (role === 'ps-csr-1' || role === 'ps-csr-2') {
    if (feature !== 'leaderboard') {
      return false
    }
  }

  return true
}
